import React, { useState } from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import { IImageWithTextDataCmp } from '../IImageWithTextCmp';
import { Typography } from '@/components/atoms';

interface IReview {
  maxWidth: number | undefined;
}

const Container = styled.div`
  .swiper-pagination-custom {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;
  }

  .swiper-pagination-bullet {
    display: inline-block;
    border-radius: 80px;
    background: ${props => props.theme.paletteDefault.white} !important;
    opacity: 1;
    width: 11px;
    height: 8px;
    border: 1px solid ${props => props.theme.paletteDefault.primary.main};
    margin-right: 16px !important;
    &:last-child {
      margin-right: 0px !important;
    }
  }
  .swiper-pagination-bullet-active {
    background: ${props => props.theme.paletteDefault.primary.main} !important;
  }
`;

const ReviewWrapper = styled.div``;
const Review = styled.div<IReview>`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : '')};
  margin: 0 auto;
`;

SwiperCore.use([Pagination]);

const ImageWithTextReviews: React.FC<IImageWithTextDataCmp> = props => {
  const { imageWithTextData, maxWidthText } = props;
  const [_, setSwiperInstance] = useState<SwiperCore>();

  const reviewSlides = imageWithTextData.map((review, index: number) => {
    return (
      <SwiperSlide key={`reviewslide-${index}`}>
        <Review maxWidth={maxWidthText}>
          <Typography align="center" datatype="subtitle_2">
            {review.description}
          </Typography>
        </Review>
      </SwiperSlide>
    );
  });
  return (
    <Container>
      <ReviewWrapper>
        <Swiper
          onSwiper={setSwiperInstance}
          loop={true}
          spaceBetween={0}
          slidesPerView={1}
          pagination={{
            el: '.swiper-pagination-custom',
            clickable: true,
            renderBullet: function (_: number, className: string) {
              return '<div class="' + className + '">' + '</div>';
            },
          }}>
          {reviewSlides}

          <div className="swiper-pagination-custom"></div>
        </Swiper>
      </ReviewWrapper>
    </Container>
  );
};

export default ImageWithTextReviews;
